import './value-proposition.scss'

const selectors = {
  container: '[data-vp]',
  dropdown: '[data-vp-dropdown]',
  dropdownHeader: '[data-vp-dropdown-header]',
  tab: '[data-vp-tab]',
  tabActive: '[data-vp-tab-active]',
  pane: '[data-vp-pane]',
  active: 'active',
}

const handleDropdownClick = (dropdown) => {
  dropdown.classList.toggle(selectors.active)
}

const handleClickOutside = (e, dropdown) => {
  if (!dropdown.contains(e.target) && dropdown.classList.contains(selectors.active)) {
    handleDropdownClick(dropdown)
  }
}

const handleTabClick = (activeIndex, tabs, panes, tabActive) => {
  panes.forEach((pane, index) => pane.classList[index === activeIndex ? 'add' : 'remove'](selectors.active))
  tabs.forEach((tab, index) => {
    const isActive = index === activeIndex

    tab.classList[isActive ? 'add' : 'remove'](selectors.active)

    if (isActive) {
      tabActive.innerText = tab.firstElementChild.innerText.trim()
    }
  })
}

const initValuePropositions = (container) => {
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  })

  const tabActive = container.querySelector(selectors.tabActive)
  const tabs = container.querySelectorAll(selectors.tab)
  const panes = container.querySelectorAll(selectors.pane)
  const dropdown = container.querySelector(selectors.dropdown)
  const dropdownHeader = dropdown?.querySelector(selectors.dropdownHeader)

  if (!tabs) return

  document.addEventListener('click', (e) => handleClickOutside(e, dropdown))
  dropdownHeader?.addEventListener('click', () => handleDropdownClick(dropdown))

  tabs.forEach((tab, index) =>
    tab.addEventListener('click', () => {
      handleTabClick(index, tabs, panes, tabActive)
      handleDropdownClick(dropdown)
    })
  )

  const initialTab = params.cat
    ? [...tabs].findIndex((tab) => {
        return tab.dataset.vpTab === params.cat
      })
    : 0

  handleTabClick(initialTab, tabs, panes, tabActive)
}

document.addEventListener('DOMContentLoaded', async function () {
  const containers = document.querySelectorAll(selectors.container)

  containers?.forEach(initValuePropositions)
})
